export function typedValues<T extends Record<PropertyKey, unknown>>(obj: T): T[keyof T][];
export function typedValues<_T extends Record<PropertyKey, unknown>>(obj: undefined): undefined;

export function typedValues<T extends Record<PropertyKey, unknown>>(obj: T | undefined) {
  if (!obj) {
    return undefined;
  }

  return Object.values(obj) as T[keyof T][];
}
